export const delegationsApiPaths = <const>{
    delegations: 'companies/delegations',
    companyDelegations: 'companies/:companyId/delegations',
};
